/* SkySimWorld Custom JS – Reveal, Count-Up, Tilt-Cards, Scroll-Velocity-Marquee, Click-Spark */
(function () {
  /* Versions-Marker (zum Prüfen, welcher Stand geladen ist) */
  document.documentElement.setAttribute('data-ssw-version', 'v116');
  /* WICHTIG: Diese Datei wird von jeder Section einmal eingebunden und liefe
     mehrfach. Bei GERADER Anzahl heben sich die Klick-Handler gegenseitig auf
     (Pfeil öffnet + schließt im selben Klick = "nichts passiert").
     Der Guard lässt nur den ersten Lauf zu. */
  if (window.__sswMainInit) return;
  window.__sswMainInit = true;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var touch = window.matchMedia('(hover: none)').matches;

  function init() {
    /* ---------- Reveal on scroll ---------- */
    var reveals = document.querySelectorAll('.ssw-reveal:not(.in)');
    if (!reduced && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.15 });
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('in'); });
    }

    /* ---------- Count-Up ---------- */
    function countUp(el) {
      var target = parseInt(el.getAttribute('data-count'), 10);
      var dur = 1400, start = performance.now();
      function tick(t) {
        var p = Math.min((t - start) / dur, 1);
        el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3))).toLocaleString('de-DE');
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }
    var counters = document.querySelectorAll('[data-count]');
    if (!reduced && 'IntersectionObserver' in window) {
      var cio = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { countUp(e.target); cio.unobserve(e.target); }
        });
      }, { threshold: 0.6 });
      counters.forEach(function (el) { cio.observe(el); });
    } else {
      counters.forEach(function (el) {
        el.textContent = parseInt(el.getAttribute('data-count'), 10).toLocaleString('de-DE');
      });
    }

    /* ---------- Tilted Cards (ReactBits-Style, dezent) ---------- */
    if (!reduced && !touch) {
      document.querySelectorAll('.ssw-card').forEach(function (card) {
        if (card.dataset.sswTilt) return;
        card.dataset.sswTilt = '1';
        var max = 5; // Grad – bewusst subtil
        card.addEventListener('mousemove', function (e) {
          var r = card.getBoundingClientRect();
          var rx = ((e.clientY - r.top) / r.height - 0.5) * -2 * max;
          var ry = ((e.clientX - r.left) / r.width - 0.5) * 2 * max;
          card.style.transform = 'rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) translateY(-3px)';
        });
        card.addEventListener('mouseleave', function () {
          card.style.transition = 'transform .35s ease, border-color .2s ease';
          card.style.transform = '';
          setTimeout(function () { card.style.transition = 'border-color .2s ease'; }, 380);
        });
      });
    }

    /* ---------- Scroll-Velocity-Marquee (ReactBits-Style) ---------- */
    if (!reduced) {
      document.querySelectorAll('.ssw-marquee-track').forEach(function (track) {
        if (track.dataset.sswVel) return;
        track.dataset.sswVel = '1';
        track.style.animation = 'none';
        var x = 0, base = 0.6, lastY = window.scrollY, boost = 0;
        function loop() {
          var y = window.scrollY;
          boost += (y - lastY) * 0.12;   // Scroll gibt Schub
          boost *= 0.92;                  // klingt weich ab
          lastY = y;
          x -= base + Math.abs(boost);
          var half = track.scrollWidth / 2;
          if (half > 0 && -x >= half) x += half;
          track.style.transform = 'translateX(' + x.toFixed(1) + 'px)';
          requestAnimationFrame(loop);
        }
        requestAnimationFrame(loop);
      });
    }

    /* ---------- Click Spark (ReactBits-Style) ---------- */
    document.querySelectorAll('.ssw-btn--primary').forEach(function (btn) {
      if (btn.dataset.sswSpark) return;
      btn.dataset.sswSpark = '1';
      btn.addEventListener('click', function (e) {
        if (reduced) return;
        for (var i = 0; i < 8; i++) {
          var s = document.createElement('span');
          s.className = 'ssw-spark';
          s.style.left = e.clientX + 'px';
          s.style.top = e.clientY + 'px';
          document.body.appendChild(s);
          var angle = (i / 8) * Math.PI * 2;
          var dist = 34 + Math.random() * 14;
          s.animate([
            { transform: 'translate(-50%,-50%) rotate(' + angle + 'rad) translateY(0) scaleY(1)', opacity: 1 },
            { transform: 'translate(-50%,-50%) rotate(' + angle + 'rad) translateY(-' + dist + 'px) scaleY(.3)', opacity: 0 }
          ], { duration: 420, easing: 'cubic-bezier(.2,.7,.3,1)' }).onfinish = (function (el) {
            return function () { el.remove(); };
          })(s);
        }
      });
    });
  }

  /* ---------- Untermenü-Dropdowns (Pfeile im Header) ---------- */
  function closeAllSubnavs(except) {
    document.querySelectorAll('.ssw-nav li.open, .ssw-mmenu-group.open').forEach(function (el) {
      if (el === except) return;
      el.classList.remove('open');
      var c = el.querySelector('.ssw-nav-caret');
      if (c) c.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) {
    /* "Was ist inbegriffen?"-Aufklapper auf Produktkarten (liegt in einem <a> → Navigation verhindern) */
    /* Bewertungs-Karussell: Pfeile scrollen die Karten-Leiste */
    var arrow = e.target.closest('.ssw-rev-arrow');
    if (arrow) {
      e.preventDefault();
      var shell = arrow.closest('.ssw-reviews-shell');
      var track = shell && shell.querySelector('.ssw-reviews-track');
      if (track) {
        var card = track.querySelector('.ssw-rev-card');
        var amt = (card ? card.offsetWidth : 320) + 22;
        track.scrollBy({ left: arrow.dataset.dir === 'prev' ? -amt : amt, behavior: 'smooth' });
      }
      return;
    }
    var inc = e.target.closest('.ssw-inc-toggle');
    if (inc) {
      e.preventDefault();
      e.stopPropagation();
      var box = inc.closest('.ssw-inc');
      var isOpen = box.classList.toggle('open');
      inc.setAttribute('aria-expanded', String(isOpen));
      return;
    }
    var caret = e.target.closest('.ssw-nav-caret');
    if (caret) {
      e.preventDefault();
      var item = caret.closest('li.has-sub, .ssw-mmenu-group');
      if (!item) return;
      var open = item.classList.contains('open');
      closeAllSubnavs(item);
      item.classList.toggle('open', !open);
      caret.setAttribute('aria-expanded', String(!open));
      return;
    }
    /* Klick außerhalb schließt offene Desktop-Dropdowns */
    if (!e.target.closest('.ssw-nav')) closeAllSubnavs(null);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllSubnavs(null);
  });

  /* ---------- Smart-Header: runter = ausblenden, hoch = sofort einblenden ----------
     (läuft auch inline in ssw-header.liquid; der Guard verhindert Doppel-Listener) */
  (function () {
    if (window.__sswSmartHeader) return;
    window.__sswSmartHeader = true;
    var lastY = window.scrollY, ticking = false;
    function update() {
      var header = document.querySelector('.ssw-header');
      if (header) {
        var y = window.scrollY;
        var menuOpen = header.querySelector('.open');           /* Dropdown/Mobile-Menü offen? Dann sichtbar lassen */
        if (y <= 120 || y < lastY - 1 || menuOpen) {
          header.classList.remove('ssw-header--hidden');
        } else if (y > lastY + 2) {
          header.classList.add('ssw-header--hidden');
        }
        lastY = y;
      }
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
  })();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify Theme-Editor: nach Section-Reload neu initialisieren
  document.addEventListener('shopify:section:load', init);
})();

/* ---------- Google-Bewertungs-Popup (unten rechts, auf jeder Seite) ----------
   Holt Gesamtnote + Anzahl vom Portal und zeigt sie als schwebendes SkySimWorld-
   Badge. Klick öffnet ein kleines Popup mit Sternen + "Auf Google bewerten". */
(function () {
  if (window.__sswGrevBadge) return;
  window.__sswGrevBadge = true;
  var API = (window.SSW_REVIEWS_API != null ? window.SSW_REVIEWS_API : 'https://internal.skysimworld.de').replace(/\/$/, '');

  function stars(n, size) {
    var s = '';
    for (var i = 1; i <= 5; i++) s += '<span style="color:' + (i <= n ? '#F7A82D' : '#3D4658') + ';">★</span>';
    return '<span style="font-size:' + (size || 15) + 'px;letter-spacing:2px;">' + s + '</span>';
  }

  function boot() {
    /* Popup nur auf der Startseite anzeigen */
    var p = location.pathname.replace(/\/+$/, '');
    if (p !== '' && p !== '/') return;
    fetch(API + '/api/reviews')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || !d.rating) return;
        var score = Number(d.rating).toFixed(1).replace('.', ',');
        var count = d.total || (d.reviews || []).length;
        var url = d.mapsUrl || 'https://www.google.com/maps/search/SkySimWorld';

        var css = document.createElement('style');
        css.textContent =
          '@keyframes ssw-gbfloat{0%,100%{translate:0 0;}50%{translate:0 8px;}}' +
          '.ssw-gbadge{position:fixed;right:18px;bottom:18px;z-index:990;font-family:inherit;}' +
          /* Schwebende abgerundete gelbe Quadrate als Deko hinter der Pille – wie auf der Website */
          '.ssw-gbadge::before{content:"";position:absolute;right:-11px;top:-17px;width:36px;height:36px;border-radius:22%;background:linear-gradient(135deg,#FFC24F,#F09819);transform:rotate(14deg);opacity:.9;z-index:-1;pointer-events:none;animation:ssw-gbfloat 7s ease-in-out infinite;}' +
          '.ssw-gbadge::after{content:"";position:absolute;left:-15px;bottom:-11px;width:17px;height:17px;border-radius:26%;border:2px solid #F7A82D;transform:rotate(-12deg);opacity:.55;z-index:-1;pointer-events:none;animation:ssw-gbfloat 9s ease-in-out infinite reverse;}' +
          '.ssw-gbadge-close{position:absolute;left:-9px;top:-9px;width:24px;height:24px;border-radius:50%;background:#161B26;border:1px solid #2E3545;color:#9BACC2;font-size:14px;line-height:1;cursor:pointer;z-index:2;display:flex;align-items:center;justify-content:center;padding:0;}' +
          '.ssw-gbadge-close:hover{color:#EAF0F7;border-color:#00B4D8;}' +
          '.ssw-gbadge-pill{display:flex;align-items:center;gap:12px;background:#161B26;border:1px solid #2E3545;border-radius:16px;padding:14px 20px;cursor:pointer;box-shadow:0 10px 34px rgba(0,0,0,.55);color:#EAF0F7;text-align:left;}' +
          '.ssw-gbadge-pill:hover{border-color:#00B4D8;}' +
          '.ssw-gbadge-pill svg{width:28px;height:28px;flex:none;}' +
          '.ssw-gbadge-col{display:flex;flex-direction:column;gap:3px;}' +
          '.ssw-gbadge-kick{font-size:11.5px;font-weight:800;letter-spacing:.14em;color:#9BACC2;text-transform:uppercase;}' +
          '.ssw-gbadge-row{display:flex;align-items:center;gap:9px;font-weight:800;font-size:21px;}' +
          '.ssw-gbadge-row .cnt{color:#9BACC2;font-weight:600;font-size:15px;}' +
          '.ssw-gbadge-pop{position:absolute;right:0;bottom:88px;width:300px;background:#161B26;border:1px solid #2E3545;border-radius:16px;padding:22px;box-shadow:0 10px 34px rgba(0,0,0,.55);color:#EAF0F7;overflow:hidden;}' +
          /* Deko im Popup: großes weiches Quadrat oben rechts + kleines Outline-Quadrat */
          '.ssw-gbadge-pop::before{content:"";position:absolute;right:-20px;top:-20px;width:74px;height:74px;border-radius:22%;background:linear-gradient(135deg,#FFC24F,#F09819);transform:rotate(16deg);opacity:.18;pointer-events:none;animation:ssw-gbfloat 8s ease-in-out infinite;}' +
          '.ssw-gbadge-pop::after{content:"";position:absolute;right:30px;top:64px;width:16px;height:16px;border-radius:26%;border:2px solid #F7A82D;transform:rotate(-12deg);opacity:.4;pointer-events:none;animation:ssw-gbfloat 10s ease-in-out infinite reverse;}' +
          '.ssw-gbadge-pop[hidden]{display:none;}' +
          '.ssw-gbadge-x{position:absolute;top:8px;right:10px;background:none;border:none;color:#9BACC2;font-size:20px;cursor:pointer;line-height:1;z-index:1;}' +
          '.ssw-gbadge-t{font-size:13px;font-weight:800;letter-spacing:.14em;color:#9BACC2;margin:0 0 10px;text-transform:uppercase;}' +
          '.ssw-gbadge-score{font-size:38px;font-weight:800;margin:0 0 2px;}' +
          '.ssw-gbadge-n{color:#9BACC2;font-size:14px;margin:4px 0 14px;}' +
          '.ssw-gbadge-btn{display:block;text-align:center;background:linear-gradient(135deg,#FFC24F,#F09819);color:#1A1204;font-weight:800;font-size:15px;border-radius:10px;padding:12px 12px;text-decoration:none;position:relative;z-index:1;}' +
          '@media (max-width:640px){.ssw-gbadge-pill{padding:11px 15px;}.ssw-gbadge-row{font-size:17px;}.ssw-gbadge::before{width:28px;height:28px;right:-8px;top:-13px;}}';
        document.head.appendChild(css);

        var G = '<svg viewBox="0 0 48 48" aria-hidden="true"><path fill="#FFC107" d="M43.6 20.1H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3l5.7-5.7C34.2 6.1 29.3 4 24 4 13 4 4 13 4 24s9 20 20 20 20-9 20-20c0-1.3-.1-2.6-.4-3.9z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.9 1.2 8 3l5.7-5.7C34.2 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z"/><path fill="#1976D2" d="M43.6 20.1H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.1 5.7l6.2 5.2C36.9 42.6 44 37 44 24c0-1.3-.1-2.6-.4-3.9z"/></svg>';

        var wrap = document.createElement('div');
        wrap.className = 'ssw-gbadge';
        wrap.innerHTML =
          '<button type="button" class="ssw-gbadge-close" aria-label="Bewertungs-Popup schließen">×</button>' +
          '<div class="ssw-gbadge-pop" hidden>' +
            '<button type="button" class="ssw-gbadge-x" aria-label="Schließen">×</button>' +
            '<p class="ssw-gbadge-t"><span class="ssw-gbadge-sq"></span>GOOGLE BEWERTUNGEN</p>' +
            '<div class="ssw-gbadge-score">' + score + '</div>' +
            stars(Math.round(d.rating), 26) +
            '<div class="ssw-gbadge-n">' + count + ' Bewertungen</div>' +
            '<a class="ssw-gbadge-btn" href="' + url + '" target="_blank" rel="noopener">Auf Google bewerten</a>' +
          '</div>' +
          '<button type="button" class="ssw-gbadge-pill" aria-label="Google Bewertungen anzeigen">' +
            G +
            '<span class="ssw-gbadge-col">' +
              '<span class="ssw-gbadge-kick"><span class="ssw-gbadge-sq"></span>Google Bewertungen</span>' +
              '<span class="ssw-gbadge-row"><b>' + score + '</b>' + stars(Math.round(d.rating), 20) + '<span class="cnt">(' + count + ')</span></span>' +
            '</span>' +
          '</button>';
        document.body.appendChild(wrap);

        var pop = wrap.querySelector('.ssw-gbadge-pop');
        wrap.querySelector('.ssw-gbadge-pill').addEventListener('click', function () { pop.hidden = !pop.hidden; });
        wrap.querySelector('.ssw-gbadge-x').addEventListener('click', function () { pop.hidden = true; });
        wrap.querySelector('.ssw-gbadge-close').addEventListener('click', function () { wrap.remove(); });
      })
      .catch(function () { /* Portal nicht erreichbar -> kein Badge */ });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
